import { type GenericMap, ScreenType } from "@client/types";

type ScreenWidths = {
  min: number;
  max?: number;
};
export const SCREEN_TO_WIDTHS: GenericMap<ScreenWidths> = {
  [ScreenType.Desktop]: {
    min: 1200
  },
  [ScreenType.Tablet]: {
    min: 770,
    max: 1199
  },
  [ScreenType.Mobile]: {
    min: 350,
    max: 769
  }
};

export const getScreenType = (width: number): ScreenType => {
  const get = (screen: ScreenType): ScreenType | undefined => {
    const widths = SCREEN_TO_WIDTHS[screen];
    return width >= widths.min && (!widths.max || widths.max >= width) ? screen : undefined;
  };

  return get(ScreenType.Desktop) ?? get(ScreenType.Tablet) ?? ScreenType.Mobile;
};

export const getDownScreen = (screen: ScreenType): ScreenType | undefined => {
  switch (screen) {
    case ScreenType.Tablet:
      return ScreenType.Mobile;
    case ScreenType.Desktop:
      return ScreenType.Tablet;
  }
};

export const getUpScreen = (screen: ScreenType): ScreenType | undefined => {
  switch (screen) {
    case ScreenType.Mobile:
      return ScreenType.Tablet;
    case ScreenType.Tablet:
      return ScreenType.Desktop;
  }
};
